import isEqual from "lodash/isEqual";
import { combineReducers } from "redux";
import {
  EDIT_DEVICE_FLAGS_SUCCESS,
  EDIT_DEVICE_PARAMS_SUCCESS,
  LOAD_DEVICES_SUCCESS,
  UPGRADE_DEVICES_SUCCESS,
  DOWNGRADE_DEVICES_SUCCESS,
  UPGRADE_DEVICES_FIRMWARE_SUCCESS,
} from "redux-store/devices/actions";
import { reduceById } from "redux-store/reducers";
import { configReducer } from "util/array";

import {
  ADD_NEW_DEVICES_TO_DEVICE_STATUSES,
  CLEAR_AND_LOAD_DEVICE_STATUSES,
  SET_DEVICE_STATUSES,
  UPDATE_ALL_DEVICE_STATUSES,
} from "./actions";

/**
 * Reduces device model to device statuses.
 *
 * @param {object} state - Old DeviceStatuses state.
 * @param {Device[]} data - devices.
 * @return {{}} - new DeviceStatuses state.
 */
function reduceDevicesById(state = {}, data = []) {
  const newState = data.reduce(
    (acc, device) => {
      acc[device.id] = device.status;

      return acc;
    },
    { ...state },
  );

  return isEqual(state, newState) ? state : newState;
}

/**
 * Reduces device-status updates to device statuses.
 *
 * @param {object} state - Old DeviceStatuses state.
 * @param {Action} action - action object.
 * @return {{}} - new DeviceStatuses state.
 */
function updateDeviceStatusReducer(state, action) {
  const { hibernating = [], online = [] } = action.payload || {};

  const hibMap = hibernating.reduce(configReducer, {});
  const onMap = online.reduce(configReducer, {});

  return Object.keys(state).reduce((acc, id) => {
    acc[id] = {
      hibernating: hibMap[id] === true,
      online: onMap[id] === true,
    };

    return acc;
  }, {});
}

function setDeviceStatusReducer(state, action) {
  const { payload } = action;

  return isEqual(state, payload) ? state : { ...payload };
}

function byId(state = {}, action) {
  const { payload, type } = action;

  switch (type) {
    case LOAD_DEVICES_SUCCESS:
      return reduceDevicesById({}, payload.data);
    case CLEAR_AND_LOAD_DEVICE_STATUSES:
      return reduceDevicesById({}, payload);
    case SET_DEVICE_STATUSES:
      return setDeviceStatusReducer(state, action);
    case UPDATE_ALL_DEVICE_STATUSES:
      return updateDeviceStatusReducer(state, action);
    case ADD_NEW_DEVICES_TO_DEVICE_STATUSES:
      return reduceById(state, payload.devices);
    case EDIT_DEVICE_FLAGS_SUCCESS:
    case EDIT_DEVICE_PARAMS_SUCCESS:
      return reduceDevicesById(state, [payload.data]);
    case UPGRADE_DEVICES_SUCCESS:
    case DOWNGRADE_DEVICES_SUCCESS:
    case UPGRADE_DEVICES_FIRMWARE_SUCCESS:
      return reduceDevicesById(state, payload.data);
    default:
      return state;
  }
}

const deviceStatusReducer = combineReducers({ byId });

export {
  byId,
  deviceStatusReducer,
  reduceDevicesById,
  setDeviceStatusReducer,
  updateDeviceStatusReducer,
};
